/* Provador Ankor — versão "Tabela de medidas" (sem avatar).
 * A janela da tabela traz o "Descubra seu tamanho" dentro, em sanfona.
 * Uso: AnkorTabela.iniciar({ base, produto: { handle, titulo, foto, tipo, tamanhos, tabela, modelagem }, aoEscolher(t), abrirAvatar() })
 * As medidas ficam no mesmo lugar do navegador que a versão com avatar ("ankor-provador-v1").
 */
(function () {
  "use strict";
  const M = window.ProvadorMotor;
  const CHAVE = "ankor-provador-v1";
  const ler = () => { try { return JSON.parse(localStorage.getItem(CHAVE)) || null; } catch (e) { return null; } };
  const gravar = (p) => { try { localStorage.setItem(CHAVE, JSON.stringify(p)); } catch (e) { /* sem armazenamento */ } };
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  // converte as respostas em palavras (versão com avatar) para a escala 1–5
  const NUM = { estreito: 2, medio: 3, largo: 4, chapada: 2, normal: 3, saliente: 4, justo: 2, regular: 3, solto: 4 };
  const num = (v) => (v == null ? 3 : NUM[v] || +v || 3);

  const ICO = {
    fechar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    mais: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9.25"/><path d="M12 7.5v9M7.5 12h9" stroke-linecap="round"/></svg>',
    menos: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9.25"/><path d="M9 9l6 6M15 9l-6 6" stroke-linecap="round"/></svg>',
  };

  function escala(id, titulo, rotulos, valor, nomes) {
    // rotulos: [esquerda, meio, direita]; nomes: texto de cada um dos 5 pontos
    return `<div class="apt-escala">
      <label for="${id}"><b>${titulo}</b></label>
      ${nomes ? `<div class="apt-valor" id="${id}-v">${nomes[valor - 1]}</div>` : ""}
      <input type="range" id="${id}" min="1" max="5" step="1" value="${valor}" ${nomes ? `aria-valuetext="${nomes[valor - 1]}"` : ""}>
      <div class="apt-rot"><span>${rotulos[0]}</span><span>${rotulos[1]}</span><span>${rotulos[2]}</span></div>
    </div>`;
  }

  function iniciar(op) {
    const base = (op.base || ".").replace(/\/$/, "");
    const P = op.produto;
    // estatística de uso (só clique, produto e tamanho — nada de altura/peso)
    const evento = (nome, extra) => { try { if (op.aoEvento) op.aoEvento(nome, Object.assign({ produto: P.handle }, extra || {})); } catch (e) { /* nunca quebra a tabela */ } };
    const produto = {
      tipo: P.tipo || (/^camiseta|^polo/.test(P.handle) ? "malha" : "plano"),
      tamanhos: P.tamanhos, med: M.alinharGrade(M.lerTabela(P.tabela), P.tamanhos), modelagem: P.modelagem,
    };
    const salvo = ler() || {};
    let perfil = { altura: salvo.altura || "", peso: salvo.peso || "", idade: salvo.idade || "", pref: num(salvo.pref), barriga: num(salvo.barriga), torax: num(salvo.torax) };
    let modelo, res;

    const dlg = document.createElement("dialog");
    dlg.className = "apv apt-dialog";
    dlg.setAttribute("aria-label", "Tabela de medidas");
    dlg.innerHTML = `
      <div class="apt-topo"><h2>Tabela de medidas</h2><button type="button" class="apt-x" aria-label="Fechar">${ICO.fechar}</button></div>
      <div class="apt-corpo">
        <p class="apt-intro">Compare suas medidas com esta tabela. Medidas da peça em cm.</p>
        <section class="apt-card">
          <button type="button" class="apt-cab" aria-expanded="false"><span class="apt-cab-tit">Descubra seu tamanho</span><span class="apt-cab-ico">${ICO.mais}</span></button>
          <div class="apt-conteudo" hidden></div>
        </section>
        <div class="apt-foto">${P.foto ? `<img src="${esc(P.foto)}" alt="" loading="lazy">` : ""}</div>
        <div class="apt-tabela-wrap"><table class="apt-tabela"></table></div>
      </div>`;
    document.body.appendChild(dlg);
    const $ = (s) => dlg.querySelector(s);
    const cab = $(".apt-cab"), cont = $(".apt-conteudo");
    $(".apt-x").onclick = () => dlg.close();
    cab.onclick = () => (cab.getAttribute("aria-expanded") === "true" ? recolher() : expandir());

    function expandir() {
      cab.setAttribute("aria-expanded", "true"); cab.querySelector(".apt-cab-ico").innerHTML = ICO.menos; cont.hidden = false;
      if (res) resultado(); else passo1();
    }
    function recolher() { cab.setAttribute("aria-expanded", "false"); cab.querySelector(".apt-cab-ico").innerHTML = ICO.mais; cont.hidden = true; }

    /* tabela da peça (só os tamanhos que a loja vende) */
    function tabela(destacar) {
      const t = P.tabela || {}, cols = t.metricHeaders || [];
      const linhas = (t.rows || []).filter((r) => P.tamanhos.indexOf(r.size) >= 0)
        .sort((a, b) => P.tamanhos.indexOf(a.size) - P.tamanhos.indexOf(b.size));
      $(".apt-tabela").innerHTML = `<thead><tr><th scope="col">Tamanho</th>${cols.map((c) => `<th scope="col">${esc(c.charAt(0) + c.slice(1).toLowerCase())}</th>`).join("")}</tr></thead>
        <tbody>${linhas.map((r) => `<tr class="${r.size === destacar ? "apt-sel" : ""}"><th scope="row">${esc(r.size)}</th>${cols.map((c) => `<td>${esc(r.values[c])}</td>`).join("")}</tr>`).join("")}</tbody>`;
    }

    const aviso = `<p class="apt-lgpd">Ao continuar, você concorda com o uso da sua altura, peso e idade apenas para recomendar o tamanho. Esses dados ficam guardados só neste navegador e não são enviados para a loja. Saiba mais na nossa <a href="/policies/privacy-policy" target="_blank" rel="noopener">Política de Privacidade</a>.</p>`;

    function passo1() {
      const PREF = ["Muito justo", "Justo", "Normal", "Folgado", "Muito folgado"];
      cont.innerHTML = `<p class="apt-sub">Calculamos o seu tamanho com base nas suas medidas.</p>
        <div class="apt-campo"><label for="apt-alt"><b>Sua altura</b></label><div class="apt-in"><input id="apt-alt" type="number" inputmode="numeric" min="140" max="210" placeholder="0" value="${esc(perfil.altura)}"><span>cm</span></div></div>
        <div class="apt-campo"><label for="apt-peso"><b>Seu peso</b></label><div class="apt-in"><input id="apt-peso" type="number" inputmode="numeric" min="40" max="180" placeholder="0" value="${esc(perfil.peso)}"><span>kg</span></div></div>
        ${escala("apt-pref", "Como você gosta de usar a roupa?", ["Muito justo", "Normal", "Muito folgado"], perfil.pref, PREF)}
        <button type="button" class="apt-btn apt-seguir">Continuar</button>${aviso}`;
      const a = $("#apt-alt"), p = $("#apt-peso"), b = $(".apt-seguir"), r = $("#apt-pref");
      const ok = () => +a.value >= 140 && +a.value <= 210 && +p.value >= 40 && +p.value <= 180;
      const checar = () => { b.disabled = !ok(); };
      a.oninput = p.oninput = checar; checar();
      r.oninput = () => { $("#apt-pref-v").textContent = PREF[r.value - 1]; r.setAttribute("aria-valuetext", PREF[r.value - 1]); };
      b.onclick = () => { if (!ok()) return; Object.assign(perfil, { altura: +a.value, peso: +p.value, pref: +r.value }); passo2(); };
      (perfil.altura ? b : a).focus();
    }

    function passo2() {
      const idades = ['<option value="">Selecione sua idade</option>'];
      for (let i = 14; i <= 90; i++) idades.push(`<option value="${i}" ${+perfil.idade === i ? "selected" : ""}>${i} anos</option>`);
      cont.innerHTML = `<p class="apt-sub">Formato da sua silhueta.</p>
        ${escala("apt-barriga", "Qual a forma do seu abdômen?", ["Reto", "Médio", "Volumoso"], perfil.barriga)}
        ${escala("apt-torax", "E do seu peito e ombros?", ["Estreitos", "Médios", "Largos"], perfil.torax)}
        <div class="apt-campo"><label for="apt-idade"><b>Qual a sua idade?</b></label>
          <p class="apt-nota">A idade muda a forma como o peso se distribui no corpo, e isso ajuda a acertar o tamanho.</p>
          <select id="apt-idade" class="apt-sel-idade">${idades.join("")}</select></div>
        <div class="apt-acoes"><button type="button" class="apt-btn apt-sec apt-voltar">Voltar</button><button type="button" class="apt-btn apt-seguir">Continuar</button></div>${aviso}`;
      const s = $("#apt-idade"), b = $(".apt-seguir");
      const checar = () => { b.disabled = !s.value; };
      s.onchange = checar; checar();
      $(".apt-voltar").onclick = () => { perfil.barriga = +$("#apt-barriga").value; perfil.torax = +$("#apt-torax").value; passo1(); };
      b.onclick = async () => {
        Object.assign(perfil, { barriga: +$("#apt-barriga").value, torax: +$("#apt-torax").value, idade: +s.value });
        gravar(perfil);
        modelo = modelo || (await fetch((op.arquivos && op.arquivos["data/modelo.json"]) || `${base}/data/modelo.json`).then((r) => r.json()));
        res = M.recomendar(modelo, perfil, produto);
        evento("tabela_resultado", { tamanho: res.melhor });
        resultado();
      };
    }

    function resultado() {
      const t = res.melhor;
      let frase = "Pode ser o seu tamanho";
      if (res.foraDaGrade) frase = "É o maior que temos, mas pode ficar justo";
      const alt = res.alternativa
        ? `<p class="apt-entre">Você está entre o <b>${t}</b> e o <b>${res.alternativa}</b>. ${perfil.pref >= 4 ? "Como você gosta mais solto, o " + (P.tamanhos.indexOf(res.alternativa) > P.tamanhos.indexOf(t) ? res.alternativa : t) + " também é uma boa." : "O " + t + " deve vestir melhor."}</p>` : "";
      cont.innerHTML = `
        <div class="apt-res-foto">${P.foto ? `<img src="${esc(P.foto)}" alt="" loading="lazy">` : ""}</div>
        <div class="apt-res-tam"><span class="apt-bola">${esc(t)}</span><span>${frase}</span></div>${alt}
        <button type="button" class="apt-btn apt-sacola">Adicionar à sacola</button>
        ${op.abrirAvatar ? `<button type="button" class="apt-btn apt-sec apt-avatar">Ver como veste no avatar 360°</button>` : ""}
        <button type="button" class="apt-btn apt-sec apt-reiniciar">Refazer</button>`;
      tabela(t);
      $(".apt-sacola").onclick = () => { evento("tabela_adicionou", { tamanho: t }); if (op.aoEscolher) op.aoEscolher(t, { adicionar: true }); dlg.close(); };
      $(".apt-reiniciar").onclick = () => { res = null; tabela(null); passo1(); };
      const av = $(".apt-avatar");
      if (av) av.onclick = () => { dlg.close(); op.abrirAvatar(); };
    }

    tabela(null);
    return {
      abrir(descobrir) {
        evento("tabela_aberta");
        if (!dlg.open) dlg.showModal();
        if (descobrir) expandir();
      },
    };
  }

  window.AnkorTabela = { iniciar };
})();
